module.exports = __webpack_public_path__ + "Journal Regular.fb5a1b81ce28eb604832.woff2";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/Journal Regular.woff2
// module id = ../../../../../src/fonts/Journal Regular.woff2
// module chunks = styles